import { styled } from '@mui/material';

export const Wrapper = styled('div')({
    position: 'relative',
    '& .recharts-bar-rectangles': {
        position: 'relative',
    },
});
